import { Component, Inject, Ref, Vue } from 'vue-property-decorator';
import * as dateUtils from '@/shared/date/date-utils';
import { BModal, BvTableFieldArray } from 'bootstrap-vue';
import BitacoraService from '@/entities/solicitud/administracion/bitacora-estados/bitacora.service';
import { RolAutoridad } from '@conacyt/perfil-usuario-client';
import { IBitacoraDetalle } from '@/shared/model/bitacora-detalle.model';

@Component
export default class BitacoraEstadosComponent extends Vue {
  @Inject('bitacoraService') private readonly bitacoraService: () => BitacoraService;

  public eventos: Array<IBitacoraDetalle> = [];

  @Ref('bitacoraEstadosModal')
  public readonly bitacoraEstadosModal: BModal;

  public readonly campos: BvTableFieldArray = [
    {
      key: 'estadoFinal',
      label: this.$t('apeironGwApp.bitacoraEstadosSolicitudes.tabla.estado').toString(),
      formatter: (value: string) => this.$t('archeApp.EstadoSolicitud.' + value).toString(),
      thStyle: { width: '8rem' },
    },
    {
      key: 'fechaCreacion',
      label: this.$t('apeironGwApp.bitacoraEstadosSolicitudes.tabla.fecha').toString(),
      formatter: dateUtils.formatDate,
      thStyle: { width: '8rem' },
    },
    {
      key: 'nombreCompleto',
      label: this.$t('apeironGwApp.bitacoraEstadosSolicitudes.tabla.nombreUsuario').toString(),
      formatter: (value: string) => (value != 'system' ? value : RolAutoridad.SISTEMA),
    },
    {
      key: 'descripcion',
      label: this.$t('apeironGwApp.bitacoraEstadosSolicitudes.tabla.descripcion').toString(),
    },
  ];

  public ocultarModalBitacoraEstados(): void {
    this.bitacoraEstadosModal.hide();
    this.eventos = [];
  }

  public mostrarModalBitacoraEstados(solicitudId: string): void {
    this.bitacoraService()
      .retrieve(solicitudId)
      .then(bitacoras => {
        this.eventos = bitacoras.data;
        this.bitacoraEstadosModal.show();
      });
  }
}
